export default {
  "IDMClientTokenKey": "844c0595-e15a-449f-a29d-ce854f530904",
  "IDMClientTokenSecret": "878304b8-085a-4ca1-8328-6f5cefcbf9f4",
  "IDMClientOptions": {
    "externalAuth": false,
    "autoEnrollRole": [
      "59a72bbd-9a43-427e-9c92-afd74ab19431"
    ],
    "apiEndpoint": "https://api-auth.ibew258.app",
    "cookiesEndpoint": "https://auth.ibew258.app",
    "roles": {
      "ADMIN": "42d2c8d0-d1c_IBEW",
      "EMPLOYER": "f7e9e474-24f_IBEW",
      "MEMBER": "c479f66c-966_IBEW"
    },
    "partitions": {}
  },
  "ApplicationName": "IBEW",
  "ApplicationAPIEndpoint": "https://api.ibew258.app",
  "ApplicationRecaptchaKey": "6Ld5uMwZAAAAALUYoCDAL5dW5dC7rp3QfUg41Rl0",
  "ApplicationRoutes": {
    "login": "/",
    "homepage": "/",
    "register": "/register",
    "registrationConfirmation": "/registrationConfirmation/:id/:id2",
    "registrationConfirmationMail": "/registrationConfirmation/:id",
    "registrationConfirmationReset": "/registrationConfirmation/reset/:id",
    "resetPassword": "/resetPass/:id",
    "resetPasswordRaw": "/resetPass/",
    "resetPasswordConfirmation": "/resetPass/confirm/:id",
    "setupPassword": "/setupPass/:id/:id2",
    "user": "/user/:id",
    "profile": "/user",
    "users": "/users",
    "authError": "/authError",
    "contactAdmin": "mailto:support@ikonintegration.com",
    "adminSettings": "/settings",
    "adminSettingsDepartments": "/settings/departments",
    "adminSettingsSchedules": "/settings/schedules",
    "adminSettingsSectors": "/settings/sectors",
    "adminSettingsAppConfig": "/settings/app-config",
    "adminSettingsDuesRates": "/settings/dues-rates",
    "adminSettingsMemberStatus": "/settings/member-status",
    "adminSettingsTrainingCodes": "/settings/training-codes",
    "adminSettingsDispatchList": "/settings/dispatch-lists",
    "adminSettingsChartOfAccounts": "/settings/chart-of-accounts",
    "adminSettingsUnits": "/settings/units",
    "adminSettingsClassifications": "/settings/classifications",
    "adminSettingsJobClassifications": "/settings/jobClassifications",
    "adminSettingsWorkActivityCodes": "/settings/work-activity-codes",
    "admins": "/admins",
    "adminsCreate": "/admin/new",
    "adminsUpdate": "/admin/update/:id",
    "adminsManageAcls": "/admin/acls/:id",
    "employers": "/employers",
    "employersCreate": "/employer/new",
    "employersUpdate": "/employer/update/:id",
    "employerRemittances": "/employer/:id/remittance",
    "remittances": "/remittances",
    "adminRemittances": "/employers/remittances",
    "adminImportRemittance": "/employers/remittances/import/:id/:id2",
    "notes": "/:id/notes/:id2",
    "contacts": "/employers/:id/contacts",
    "dispatch": "/dispatch",
    "members": "/members",
    "memberCreate": "/member/new",
    "memberUpdate": "/member/update/:id",
    "memberWorkHistory": "/member/:id/work-history",
    "memberDuesHistory": "/member/:id/dues-history",
    "memberDispatchNotes": "/member/:id/dispatch-notes",
    "reportMembersLabel": "/reports/members/label",
    "reportMembersList": "/reports/members/list",
    "reportShopStewards": "/reports/shop-stewards",
    "reportMembersArrears": "/reports/members/arrears",
    "ioPerCapita": "/reports/members/io",
    "reportCustomMembersReport": "/reports/members/custom",
    "reportMembersDuesPosting": "/reports/members/dues-posting",
    "reportMembersDuesPostingByType": "/reports/members/dues-posting-by-type",
    "reportEmployersLabel": "/reports/employers/label",
    "reportDispatchList": "/reports/dispatchList",
    "reportTaxReceipts": "/reports/taxReceipts",
    "reportDispatchSlip": "/reports/dispatchSlip",
    "reportActiveMembers": "/reports/activeMembers",
    "reportEmploymentByClassification": "/reports/employment-by-classification",
    "dispatchJob": "/dispatch-job",
    "crateDispatchJob": "/dispatch-job/new",
    "duesBatches": "/duesBatches",
    "duesBatchUpdate": "/duesBatch/:id/:id2",
    "updateDispatchJob": "/employer/:id/dispatch-job/update/:id2",
    "dispatchMembers": "/employer/:id/dispatch-job/:id2/dispatch-members",
    "employerDispatchNotes": "/employer/:id/dispatch-notes/:id2",
    "trainingHistory": "/training-history/:id",
    "reportArrearsLetters": "/reports/arrears-letters",
    "resetYTD": "/reset-ytd",
    "applicationForm": "/application-form",
    "applications": "/applications",
    "duesHistory": "/dues-history",
    "workHistory": "/work-history",
    "memberDispatch": "/dispatch",
    "reportMembersDuesYTD": "/reports/members-dues-ytd"
  },
  "Theme": {
    "colors": {
      "@primary-color": "#D7503F",
      "@link-color": "#D6664A",
      "@redMain": "#D6664A",
      "@greyDark": "#136fba"
    },
    "privacyURL": null,
    "helpURL": null,
    "termsURL": null
  },
  "LogRocketOptions": {
    "applicationId": "ibew-dialr/ibew-fe"
  }
};
